import { cn } from '@/lib/utils';
import { Capacitor } from '@capacitor/core';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { InfoStep } from './step-info';
import { LanguageStep } from './step-language';
import { TermsStep } from './step-terms';

type Step = 'language' | 'terms' | 'info';

const STEPS: Step[] = ['language', 'terms', 'info'];

export function OnboardingFlow() {
  const [step, setStep] = useState<Step>('language');
  const currentStepIndex = STEPS.indexOf(step);
  const totalSteps = STEPS.length;
  const isMobile = Capacitor.isNativePlatform();

  return (
    <div
      key="onboarding"
      className={cn(
        'flex w-full flex-col items-center justify-center px-6 pt-10 pb-2',
        isMobile ? 'h-full' : 'h-dvh pb-8',
      )}>
      <AnimatePresence mode="wait">
        {step === 'language' && (
          <LanguageStep
            key="language"
            onNext={() => setStep('terms')}
            currentStep={currentStepIndex}
            totalSteps={totalSteps}
          />
        )}
        {step === 'terms' && (
          <TermsStep
            key="terms"
            onBack={() => setStep('language')}
            onNext={() => setStep('info')}
            currentStep={currentStepIndex}
            totalSteps={totalSteps}
          />
        )}
        {step === 'info' && (
          <InfoStep
            key="info"
            onBack={() => setStep('terms')}
            currentStep={currentStepIndex}
            totalSteps={totalSteps}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
